export const markerUnitEntityName = 'marker_unit'
